import React from "react";
import styled from "styled-components";

const Styled = styled.span`
  padding: 0.5rem;
  font-size: 0.9rem;
  font-family: input-mono;
  background-color: #f7f7f7;
  border: solid 1px #ddd;
  border-radius: 0.3rem;
`;

const ObjectiveBadge: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return <Styled {...props}>{props.children}</Styled>;
};

export default ObjectiveBadge;
